import styled from "styled-components"
import { themeGet } from "@styled-system/theme-get"
import { device } from "../../../theme"

export const PageContentWrap = styled.section`
  padding-bottom: 56px;
  ${device.small} {
    padding-bottom: 76px;
  }
  ${device.medium} {
    padding-bottom: 96px;
  }
`

export const ContentTop = styled.div`
  margin-bottom: 38px;
`

export const PageContent = styled.div`
  margin-bottom: 38px;
`

export const List = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
  li {
    margin-bottom: 11px;
    position: relative;
    padding-left: 18px;
    &:before {
      position: absolute;
      content: "";
      left: 0;
      top: 7px;
      width: 6px;
      height: 6px;
      background: #99999c;
      border-radius: 50%;
    }
  }
`

export const Quote = styled.blockquote`
  position: relative;
  padding: 40px 25px 40px;
  background: ${themeGet("colors.themeColor")};
  text-align: center;
  border-radius: 5px;
  margin-top: 35px;
  margin-bottom: 35px;
  ${device.large} {
    padding: 50px 31px 50px;
  }
  .icon {
    width: 30px;
    height: 30px;
  }
  h3 {
    font-size: 18px;
    line-height: 1.5;
    margin-bottom: 20px;
    ${device.large} {
      font-size: 22px;
      margin-bottom: 39px;
    }
  }
  footer {
    font-size: 18px;
    color: #333;
    margin-bottom: 0;
  }
`

export const ContentBottom = styled.div`
  border-top: 1px solid ${themeGet("colors.borderColor")};
  padding-top: 42px;
  margin-top: 35px;
`
